import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {useSubheader} from "../../../_metronic/layout/_core/MetronicSubheader";
import {useTranslation} from "react-i18next";
import {setHeaderImg, setLogo} from "../../redux/Layout/layoutSlice";
import FormComponent from "./FormComponent";
import DetailLateralComponent from "./DetailLateralComponent";
import SecurityComponent from "./SecurityComponent";
import {Route, Switch, useRouteMatch} from "react-router-dom";
import MenuLateralComponent from "./MenuLateralComponent";
import {fetchParameters} from "../../redux_slices/userParametersSlice";
import Swal from "sweetalert2";
import {loadParameter} from "../../redux_slices/contextSlice";

const ProfilePage = () => {
    const {t} = useTranslation();
    const subheader = useSubheader();

    const dispatch = useDispatch();
    //START: CLEAR IT
    const _setHeaderImg = imgSrc => dispatch(setHeaderImg(imgSrc));
    const _setLogo = logo => dispatch(setLogo(logo));
    const homePic = useSelector(state => loadParameter(state, "homePic"));
    const corporativeLogo = useSelector(state => state.settings?.settings?.corporativeLogo);
    useEffect(() => {
        _setHeaderImg(homePic);
        _setLogo(corporativeLogo);
    }, [homePic, corporativeLogo, _setHeaderImg, _setLogo]);
    useEffect(() => {
        subheader.setTitle("Profile");
        return () => subheader.setTitle("");
    }, [subheader]);
    //ENND: CLEAR IT

    const user = useSelector(state => state.userParameters.credential);
    const userParametersStatus = useSelector(state => state.userParameters.status);

    useEffect(() => {
        dispatch(fetchParameters());
    }, []);

    useEffect(() => {
        if (userParametersStatus.type === "failed") {
            Swal.fire({icon: "error", text: t(userParametersStatus.error)});
        }
    }, [userParametersStatus]);

    const match = useRouteMatch();

    return (
        <div className="container">
            <div className="row justify-content-between">
                <div className="col-12 col-md-3 d-flex flex-column">
                    <DetailLateralComponent />
                    <MenuLateralComponent />
                </div>

                <div className="col-12 col-md-9">
                    <Switch>
                        <Route exact path={`${match.path}/access`}>
                            <SecurityComponent />
                        </Route>
                        <Route exact path={`${match.path}/external`}>
                            <SecurityComponent />
                        </Route>
                        <Route path={`${match.path}/`}>
                            <FormComponent />
                        </Route>
                    </Switch>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
